import { render, staticRenderFns } from "./faturacao.vue?vue&type=template&id=cf75142a&"
import script from "./faturacao.vue?vue&type=script&lang=js&"
export * from "./faturacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports